import React from "react"
import Carousel from "@airasia/phoenix-widgets/widgets/Carousel"

import { GTM_PROJECT_CATEGORY } from "../../utils/constants"
import { getGtmUserType, fireGtmEvent } from "../../utils/functions"
// import { Zoom } from "@material-ui/core"

export default function CarouselWrapper(props) {
// console.log("props flex card",props.countryUrl)
  let countryURL = props.countryUrl
  const title = props.dataTitle?props.dataTitle:"Vegetarian"
  const carouselLabel = props.data?props.data.map(function(elem){return elem.name }).join("|"):"Asian"
  const positionLabelMerchants = props.data.map(function(elem,index){return index+1 }).join("|")
  const positionLabel = props.numberOfCarousels?props.numberOfCarousels:1;
  const gtmUserType = getGtmUserType()

  const cardData = props.data.map((x, index) => {
    let storeName = x.name?x.name.replace(/[-(_)]/g, ''):null
    storeName = storeName.replace("  ", " ")
    let promotion = x.promotions ? x.promotions : ''
    // console.log("promotions",x.promotions)
    let promotionCode = promotion? x.promotions[0].code : ''
    let storeTags=[]
      let ctaText= "Order Now"
    if (countryURL === "/th/th/")
      ctaText= "สั่งซื้อเลย";
    if (countryURL === "/id/id/")
      ctaText= "Pesan Sekarang";
    if(x.store_tags){
      x.store_tags.forEach((tag, tagIndex) => {
        storeTags.push(tag.name)
      })
    }
    return {
      attractText: "",
      chinaURL: "",
      cndisclaimerLine1: "",
      cndisclaimerLine2: "",
      companyName: "",
      companyURL: "",
      countDown: "",
      couponBoxCtaText: 'Copy',
      couponBoxLabel: 'Coupon',
      cta: ctaText,
      currencyCode: "",
      discount: "",
      // discount: x.promotions?x.promotions[0].description:"",
      hidden: "",
      image: x.image_url ? x.image_url : "https://images.contentstack.io/v3/assets/bltdf38de19a247654d/blte5b8c0f10d87a3ab/6071b2708489c6680286d902/dipdip.jpeg?quality=50&width=360&format=webp",
      labelColor: "",
      location: "",
      mobileAppImageURL: "",
      newTab: "FALSE",
      position: "",
      price: x.price,
      priceClarification: "",
      priceDisclaimer: "",
      primaryLabel: promotionCode ? promotionCode :"",
      productID: "",
      productType: "",
      promotionCouponCode: promotionCode ? promotionCode :"",
      promotionTnC: x.promotions && x.promotions[0].description?x.promotions[0].description:"",
      rating: "",
      secondaryImage: "",
      secondaryLabel: "",
      star: "",
      subtitle: storeTags.length?storeTags.join(', '):"",
      subtitleExpandCtaText: x.promotions?'know more':"",
      timer: "",
      title: x.name,
      url: x.store_url ? x.store_url : `https://www.airasia.com/food/my/restaurant/${storeName.split(' ').join('-').toLowerCase()}`
    }
  })
  return (
    <Carousel
      accessible
      cardConfig={{
        focusEffect: true
      }}
      data={[...cardData]}
      heading={{
        cardCount: "5",
        gtmParameters: {
          event: "trackEventNoEcommerce",
          eventActionClick: "click",
          eventActionView: "view",
          eventCategory: `${GTM_PROJECT_CATEGORY}|carousel|${title}|${positionLabel}`,
          eventLabelCardClick: `${GTM_PROJECT_CATEGORY}|{{cardtitle}}|{{cardposition}}`,
          eventLabelHeadlineClick: `${gtmUserType}|headline|{{headline}}`,
          eventLabelView: `${carouselLabel}|${positionLabelMerchants}`
          // eventLabelView: `${GTM_PROJECT_CATEGORY}|${gtmUserType}`
        },
        headline: '',
        // headlineStyle: 'h2',
        layoutName: "lob_widget",
        showMoreURL: "",
        subHeadline: "",
        widgetID: "",
        widgetName: "Hotel Location Widget",
        widgetWidth: "3"
      }}
      gtmConsumerName={props.gtmConsumerName}
      fireGtm={obj => {
        fireGtmEvent(obj)
      }}
      isLoading={false}
      handleClick={function noRefCheck() {
      }}
      templateType="productCard"
      theme="AIRASIA_CLASSIC"
      lazyLoadImage={true}
      enableProgressiveImageLoading={true}
    />
  )
}
